<template>
  <b-card :class="{ procedure: isProcedure }" class="item-card">
    <options :item="item"/>

    <h2 class="item-title">
      <span v-if="isProcedure">{{ rowNumber }}.</span>
      Row
    </h2>

    <b-form-checkbox
      :disabled="saving || fetching"
      v-model="item.is_procedure"
      :value="1"
      :unchecked-value="0">
      Procedure
    </b-form-checkbox>

    <b-input
      v-validate="'required'"
      :disabled="saving || fetching"
      :class="{ 'is-invalid' : errors.has('title') || item.apiErrors.length }"
      v-model="item.text"
      :value="item.text"
      type="text"
      name="title"
      placeholder="Row Title"/>
    <validation-errors :validation-errors="[errors.first('title')]"/>
    <validation-errors v-if="!errors.has('title')" :validation-errors="item.apiErrors"/>

    <template v-if="children">
      <template v-for="child in children">
        <item-add
          :key="child.id + 1"
          :level="1"
          :parent-id="item.id"
          :next-id="child.id"/>
        <component
          :key="child.id"
          :id="child.id"
          :level="1"
          :is="'item-' + child.type"/>
      </template>
    </template>

    <item-add :parent-id="item.id"/>

  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import options from './options'
import itemParagraph from './paragraph'
import itemAdd from './add'
import itemImage from './image'
import itemVideo from './video'
import itemPdf from './pdf'
import itemAudio from './audio'
import validationErrors from '../../../common/form/validation-errors'

export default {
  components: {
    options,
    itemAdd,
    itemParagraph,
    itemImage,
    itemVideo,
    itemPdf,
    itemAudio,
    validationErrors
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('items', [
      'current',
      'saving',
      'fetching'
    ]),
    item () {
      return this.$store.getters['items/byID']({id: this.id})
    },
    children () {
      return this.$store.getters['items/children']({id: this.id})
    },
    rowNumber() {
      return this.$store.getters['items/rowNumber']({rowID: this.item.id, editing: true})
    },
    isProcedure () {
      return Number(this.item.is_procedure) === 1
    },
    text () {
      return this.item.text
    }
  },
  watch: {
    text (newText, oldText) {
      if (this.item.apiErrors.length) {
        this.$store.commit('items/setProps', {
          id: this.item.id,
          props: {
            apiErrors: []
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

h2 {
  display: inline-block;
  margin-right: $spacing-sm !important;
}

.procedure {
  background: repeating-linear-gradient(
  45deg,
  $light-primary,
  $light-primary 20px,
  #fbfbfb 20px,
  #fbfbfb 40px
  );
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/items/row.vue